import { useEffect, useState } from 'react';

const getIsVisible = (): boolean =>
  typeof document === 'undefined' || document.visibilityState !== 'hidden';

/** True while the tab is in the foreground; false when it is a background tab or minimized. */
const useIsDocumentVisible = (): boolean => {
  const [isVisible, setIsVisible] = useState<boolean>(getIsVisible);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const onChange = () => setIsVisible(getIsVisible());
    onChange();
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return isVisible;
};

export default useIsDocumentVisible;
